function sortAlphabetically(a, b) {
  const textA = a.formatedData ? a.formatedData.name : a.name;
  const textB = b.formatedData ? b.formatedData.name : b.name;
  let returnValue = 0;

  if (textA.toUpperCase() < textB.toUpperCase()) {
    returnValue = -1;
  } else if (textA.toUpperCase() > textB.toUpperCase()) {
    returnValue = 1;
  }

  return returnValue;
}

function getUrlRegion(routeLevels, levels) {
  return levels.reduce((accumulator, currentValue, currentIndex) => accumulator
    .replace(
      `--level${currentIndex + 1}--`,
      currentValue.slug,
    ),
  routeLevels['routeLevel'.concat(levels.length)]);
}

function processRegions(regions, configRegions, i18n) {
  const level1 = [];
  const level2 = [];
  const level3 = [];
  const level4 = [];

  Object.keys(regions).forEach((keyFirstLevel) => {
    const levels = regions[keyFirstLevel];

    Object.values(levels).forEach((firstLevel) => {
      level1.push({
        level: 1,
        id: firstLevel.id,
        desc: i18n.level1,
        name: firstLevel.name,
        href: getUrlRegion(configRegions, [
          { slug: firstLevel.slug },
        ]),
      });

      Object.keys(firstLevel.children).forEach((keySecondLevel) => {
        const secondLevel = firstLevel.children[keySecondLevel];

        level2.push({
          level: 2,
          id: secondLevel.id,
          desc: i18n.level2,
          name: secondLevel.name,
          href: getUrlRegion(configRegions, [
            { slug: firstLevel.slug },
            { slug: secondLevel.slug },
          ]),
        });

        Object.keys(secondLevel.children).forEach((keyThirdLevel) => {
          const thirdLevel = secondLevel.children[keyThirdLevel];

          level3.push({
            level: 3,
            id: thirdLevel.id,
            desc: i18n.level3,
            name: thirdLevel.name,
            href: getUrlRegion(configRegions, [
              { slug: firstLevel.slug },
              { slug: secondLevel.slug },
              { slug: thirdLevel.slug },
            ]),
          });

          if (thirdLevel.children) {
            Object.keys(thirdLevel.children).forEach((keyForthLevel) => {
              const fourthLevel = thirdLevel.children[keyForthLevel];

              level4.push({
                level: 4,
                id: fourthLevel.id,
                desc: i18n.level4,
                name: `${fourthLevel.name} (${thirdLevel.name})`,
                href: getUrlRegion(configRegions, [
                  { slug: firstLevel.slug },
                  { slug: secondLevel.slug },
                  { slug: thirdLevel.slug },
                  { slug: fourthLevel.slug },
                ]),
              });
            });
          }
        });
      });
    });
  });

  const regionLevels = level1.sort(sortAlphabetically)
    .concat(
      level2.sort(sortAlphabetically)
        .concat(level3.sort(sortAlphabetically).concat(level4.sort(sortAlphabetically))),
    );

  return regionLevels;
}

module.exports = {
  processRegions,
};
